import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { $t } from '../../composables/i18n'
import { StringUtils } from '../../utils/String'

export enum TaxExemptionId {
  MINOR = 1,
  ZTP_HOLDER = 2,
  HOSPITALIZED = 3,
  CHILD_CARE = 4,
  SEASONAL_WORKER = 5,
  RESCUE_WORK = 6,
  UNIFORMED_SERVICES = 7,
  STAY_OVER_60_DAYS = 8,
  INHABITANT = 9,
  CUSTOM = 99, // Used for backward compatibility with P1, where Commission_Guest uses only string for custom tax exemption
}

export class TaxExemption {
  private constructor(
    public readonly id: TaxExemptionId,
    public readonly name: () => string,
  ) {}

  static readonly MINOR = new TaxExemption(TaxExemptionId.MINOR, () => $t('Younger than 18'))
  static readonly ZTP_HOLDER = new TaxExemption(TaxExemptionId.ZTP_HOLDER, () => $t('ZTP holder'))
  static readonly HOSPITALIZED = new TaxExemption(TaxExemptionId.HOSPITALIZED, () =>
    $t('Hospitalized'),
  )
  static readonly CHILD_CARE = new TaxExemption(TaxExemptionId.CHILD_CARE, () => $t('Child care'))
  static readonly SEASONAL_WORKER = new TaxExemption(TaxExemptionId.SEASONAL_WORKER, () =>
    $t('Seasonal worker'),
  )
  static readonly RESCUE_WORK = new TaxExemption(TaxExemptionId.RESCUE_WORK, () =>
    $t('Rescue work'),
  )
  static readonly UNIFORMED_SERVICES = new TaxExemption(TaxExemptionId.UNIFORMED_SERVICES, () =>
    $t('Uniformed services'),
  )
  static readonly STAY_OVER_60_DAYS = new TaxExemption(TaxExemptionId.STAY_OVER_60_DAYS, () =>
    $t('Stay over 60 days'),
  )
  static readonly INHABITANT = new TaxExemption(TaxExemptionId.INHABITANT, () => $t('Inhabitant'))
  public nameCapitalize(): string {
    return StringUtils.capitalize(this.name())
  }

  static addCustom = (customTaxExemption: string): TaxExemption => {
    if (customTaxExemption.trim() === '') {
      throw new Error('Custom tax exemption cannot be empty')
    }

    const customId: TaxExemptionId = TaxExemptionId.CUSTOM
    const customName: () => string = () => customTaxExemption

    return new TaxExemption(customId, customName)
  }

  static getById = (id: TaxExemptionId): TaxExemption => {
    const value: TaxExemption | undefined = TaxExemption.all().find(
      (item: TaxExemption): boolean => item.id === id,
    )

    if (value === undefined) {
      throw new CodebookValueNotFoundError(TaxExemption.name, id)
    }

    return value
  }

  static all = (): TaxExemption[] => {
    return [
      TaxExemption.MINOR,
      TaxExemption.ZTP_HOLDER,
      TaxExemption.HOSPITALIZED,
      TaxExemption.CHILD_CARE,
      TaxExemption.SEASONAL_WORKER,
      TaxExemption.RESCUE_WORK,
      TaxExemption.UNIFORMED_SERVICES,
      TaxExemption.STAY_OVER_60_DAYS,
      TaxExemption.INHABITANT,
    ]
  }
}
